import { ELinksCore, EAbleyLinksModule, type ILinksSystemLayers } from './interfaces';
import type { AttributesLayoutHelper } from '#lib/components/Attributes.types.js';
import { attributesColumnsOf, tableTabsOf, type ModuleEntry } from '#lib/common/moduleTable.js';

import styleAadt from './layer_styles/aadt_style.json';
import styleCounts from './layer_styles/counts_style.json';

const attributeAadtBands: AttributesLayoutHelper = {
	title: { accessorKey: 'aadt_detail_band', cell: (info) => `${info} vpd` },
	table: [
		{
			accessorKey: 'frc',
			header: () => 'Functional Road Class'
		},
		{ accessorKey: 'county', header: () => 'SA3 name' },
		{ accessorKey: 'region', header: () => 'SA4 name' }
	]
};

const attributeCounts: AttributesLayoutHelper = {
	title: { accessorKey: 'station_id', cell: (info) => `Id: ${info}` },
	body: [
		{ accessorKey: 'count', header: () => 'Count', cell: (info) => `${info} vpd` },
		{ accessorKey: 'year', header: () => 'Year' }
	]
};

// Layer keys must match the GeoServer feature titles.
export const moduleTable: Record<string, ModuleEntry> = {
	[EAbleyLinksModule.core]: {
		label: 'AADT',
		layers: {
			[ELinksCore.Aadt]: {
				map: { style: styleAadt, zIndex: 4 },
				attributes: attributeAadtBands,
				table: {
					tabId: 'Aadt',
					label: 'Aadt',
					rowLabel: 'aadt',
					columns: [
						{ accessorKey: 'county', header: 'SA3 name' },
						{ accessorKey: 'region', header: 'SA4 name' },
						{ accessorKey: 'frc', header: 'Functional Road Class' },
						{ accessorKey: 'aadt_band', header: 'AADT band' }
					]
				}
			},
			[ELinksCore.Counts]: {
				map: { style: styleCounts, zIndex: 3 },
				attributes: attributeCounts,
				table: {
					tabId: 'Counts',
					label: 'Counts',
					rowLabel: 'count site',
					// Scaffolding: adjust accessors once the counts schema is finalised.
					columns: [
						{ accessorKey: 'station_id' },
						{ accessorKey: 'year' },
						{ accessorKey: 'count' }
					]
				}
			}
		}
	}
};

export const attributesColumns = attributesColumnsOf(moduleTable);

export const tableTabs = tableTabsOf<ILinksSystemLayers>(moduleTable);
